import { IncomeDataT, IncomeRequestT } from '../../types';
import { SerializeT } from '../../types/transform';
import { buildIncomeSubmitRequest } from '../../utils';

export const serializeIncome: SerializeT<IncomeDataT, IncomeRequestT> = (income) => {
  // TODO: extract serialization from buildIncomeSubmitRequest function
  return buildIncomeSubmitRequest(income) as IncomeRequestT;
};
